var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 172 172",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,172v-172h172v172z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86,6.88c-43.62608,0 -79.12,35.49392 -79.12,79.12c0,43.62608 35.49392,79.12 79.12,79.12c43.62608,0 79.12,-35.49392 79.12,-79.12c0,-15.81368 -4.67963,-30.54898 -12.70515,-42.9261l-3.07047,3.07047l-1.96187,1.96188c6.83872,11.03208 10.8575,23.98583 10.8575,37.89375c0,39.8352 -32.4048,72.24 -72.24,72.24c-39.8352,0 -72.24,-32.4048 -72.24,-72.24c0,-39.8352 32.4048,-72.24 72.24,-72.24c16.90183,0 32.406,5.908 44.72,15.67484v6.98078l-8.37828,8.37828c-9.70193,-8.57967 -22.40322,-13.8339 -36.34172,-13.8339c-30.34768,0 -55.04,24.69232 -55.04,55.04c0,30.34768 24.69232,55.04 55.04,55.04c30.34768,0 55.04,-24.69232 55.04,-55.04c0,-11.45176 -3.52422,-22.09625 -9.5339,-30.91297l-4.98531,4.98531c4.80912,7.49576 7.63922,16.37821 7.63922,25.92765c0,26.5568 -21.6032,48.16 -48.16,48.16c-26.5568,0 -48.16,-21.6032 -48.16,-48.16c0,-26.5568 21.6032,-48.16 48.16,-48.16c12.04446,0 23.03115,4.47797 31.47735,11.81828l-12.20125,12.20125c-5.29299,-4.24538 -11.97799,-6.81953 -19.2761,-6.81953c-17.06928,0 -30.96,13.89072 -30.96,30.96c0,17.06928 13.89072,30.96 30.96,30.96c17.06928,0 30.96,-13.89072 30.96,-30.96c0,-4.77128 -1.11703,-9.27129 -3.05031,-13.30985l-5.24734,5.24063c0.90128,2.52496 1.41765,5.2381 1.41765,8.06922c0,13.2784 -10.8016,24.08 -24.08,24.08c-13.2784,0 -24.08,-10.8016 -24.08,-24.08c0,-13.2784 10.8016,-24.08 24.08,-24.08c5.40067,0 10.37206,1.80956 14.39156,4.82406l-12.61781,12.61781c-0.57819,-0.15753 -1.17449,-0.23884 -1.77375,-0.24187c-3.79972,0 -6.88,3.08028 -6.88,6.88c0,3.79972 3.08028,6.88 6.88,6.88c3.79972,0 6.88,-3.08028 6.88,-6.88c-0.00025,-0.60121 -0.07931,-1.1998 -0.23515,-1.78047l42.93953,-42.93953h8.89563l17.2,-17.2h-13.76v-13.76l-13.32328,13.32328c-13.42317,-10.48754 -30.28098,-16.76328 -48.59672,-16.76328z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoal);
export default __webpack_public_path__ + "static/media/goal.6a35fc4c5308f52470ca18c9983aec2a.svg";
export { ForwardRef as ReactComponent };